import { _ } from "../../core/polyglot/polyglot.js";
import externalDocument from "../shared/externalDocument.js";
import loadingService from "./loadingService.js";
import OldSpinnerWidget from "../../deprecated/OldSpinnerWidget/OldSpinnerWidget.js"; // eslint-disable-line import-x/no-deprecated -- todo: migrate to new spinner

/**
 * Todo: Add JSDoc comment
 */
export default function loadCompanyDocument(spec, my) {
	spec ||= {};
	my ||= {};

	const that = externalDocument(spec, my);

	that.pageTitle = _("My Companies");

	that.showHeader = true;
	that.documentId = "no-leftmenu-toggler admin-body my-companies-body";

	// eslint-disable-next-line import-x/no-deprecated -- todo: migrate to new spinner
	my.spinner = new OldSpinnerWidget({
		size: 68,
		dark: true,
	});

	that.loadCompany = function (id) {
		loadingService.loadCompany({
			id,
			callback: function () {
				my.redirectToCompany(id);
			},
			onError: function () {
				my.redirectToCompany(id);
			},
		});
	};

	my.renderContentOn = function (html) {
		html.div(
			{ class: "row" },
			html.div(
				{
					"data-type": "0",
					id: "loading-progress",
					class: "col-sm-4 col-sm-offset-4 text-center",
				},
				my.spinner,
			),
		);
	};

	that.headerButtons = function () {};

	my.redirectToCompany = function (companyId) {
		my.redirectToLocationPath(
			`/Navigate/ToAccounting?companyId=${companyId}`,
		);
	};

	my.hasSearchField = function () {
		return false;
	};

	return that;
}
